import React, { useEffect } from "react";
import { motion } from "framer-motion";

import { Image } from "../..";
import { Heading2, Paragraph } from "../../Typography";
import * as Styled from "./styles";

const BioWithImageAndQuote = ({ duration, slideType, name }) => {
  const parentVertical = {
    initial: { y: 800 },
    animate: {
      y: 0,
      transition: {
        staggerChildren: 0.5,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };

  const childVertical = {
    initial: { y: 800 },
    animate: {
      y: 0,
      transition: {
        duration: 1,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };
  const parentLeft = {
    initial: { x: -800 },
    animate: {
      x: 0,
      transition: {
        staggerChildren: 0.5,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };

  const childLeft = {
    initial: { x: -800 },
    animate: {
      x: 0,
      transition: {
        duration: 1,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };
  const parentRight = {
    initial: { x: 800 },
    animate: {
      x: 0,
      transition: {
        staggerChildren: 0.5,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };

  const childRight = {
    initial: { x: 800 },
    animate: {
      x: 0,
      transition: {
        duration: 1,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };

  return (
    <Styled.BioWithImageAndQuoteWrapper>
      <div className="vh-100 ph3">
        <div className="flex ml4 items-center vh-100 z-0">
          <div className="h-100 flex flex-column justify-between">
            <div className="bg-gray w2 h4"></div>
            <div className="bg-gray w2 h4"></div>
            <div className="bg-gray w2 h4"></div>
            <div className="bg-gray w2 h4"></div>
          </div>
        </div>

        <motion.div
          variants={parentVertical}
          initial="initial"
          animate="animate"
          style={{ marginTop: "5vmin" }}
          className="absolute bottom-0 right-0 f1 "
        >
          <div className="flex justify-end pr4">
            <motion.div variants={childVertical} className="w-10">
              {" "}
              <Image
                src={`https://bwsj-dev-api-upload.s3.amazonaws.com/BWSJ_logo_white_222b624880.svg`}
                fallback={`https://bwsj-dev-api-upload.s3.amazonaws.com/BWSJ_logo_white_222b624880.svg`}
                type={`image/svg+xml`}
              />
            </motion.div>
          </div>
        </motion.div>
        <div className="vh-100 absolute top-2 right-0 flex flex-row justify-around items-center mt4">
          <div style={{ height: "85%" }} className="flex justify-around">
            <motion.div
              variants={parentLeft}
              initial="initial"
              animate="animate"
              className="h-100 w-50 mr5 ml6 flex flex-column"
            >
              {slideType?.[0]?.quote && (
                <motion.div variants={childLeft} class="w-90 mb4">
                  <Styled.Quote>“</Styled.Quote>
                  <Heading2>{slideType?.[0]?.quote?.toUpperCase()}</Heading2>
                </motion.div>
              )}
              <motion.div variants={childLeft} className="w-60">
                <Image
                  src={slideType?.[0]?.image?.url}
                  type={slideType?.[0]?.image?.mime}
                  fallback={slideType?.[0]?.image?.url}
                />
              </motion.div>
            </motion.div>
            <motion.div
              variants={parentRight}
              initial="initial"
              animate="animate"
              className="w-30 mr4"
            >
              <Heading2 variants={childRight}>
                {slideType?.[0]?.Title?.toUpperCase()}
              </Heading2>
              <Paragraph variants={childRight}>{slideType?.[0]?.Bio}</Paragraph>
            </motion.div>
          </div>
        </div>
      </div>
    </Styled.BioWithImageAndQuoteWrapper>
  );
};

export default BioWithImageAndQuote;
